<div class="aside-content aside-width-10">

  <div class="aside-header">
    <h3>2FA Management</h3>
  </div>

  <div class="fx-layout-column fx-gap-10">

    <div class="fx-layout-row fx-gap-10">
      <button mat-raised-button (click)="generate()" [disabled]="disableGenerate" color="primary">Generate
      2FA</button>
      <button mat-raised-button (click)="disable()" [disabled]="disable2FA" color="primary">Disable 2FA</button>
      <button mat-raised-button (click)="cancel()" color="primary" class="cancel-btn">Close</button>
    </div>

    <div class="twofa-layout">

      <div class="twofa-instructions">
        <ol>
          <li>Download an authenticator app on your mobile device — such as
            <a target="_blank"
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">Google
            Authenticator</a>,
            <a target="_blank"
              href="https://play.google.com/store/apps/details?id=com.azure.authenticator">Microsoft
            Authenticator</a>, or the
            <a target="_blank"
              href="https://support.apple.com/guide/iphone/automatically-fill-in-verification-codes-ipha6173c19f/ios">built-in
            iOS authenticator</a>.
          </li>
          <li>When ready, click <strong>'Generate 2FA'</strong> above, then open your authenticator app and scan the QR code that appears.
        </li>
        <li>Enter the <strong>6-digit code</strong> from your authenticator app into the field on the right.</li>
        <li>Once verified, <strong>2FA will be enabled</strong> for your account.</li>
      </ol>
    </div>

    <div class="twofa-qr-otp">
      @if (qrValue) {
        <qrcode [qrdata]="qrValue" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
      }

      @if (qrValue) {
        <div class="card" [formGroup]="otpForm">
          <div class="card-heading">
            <mat-icon style="font-size: 48px; color: #dc385f;" class="icon icon-circle">security</mat-icon>
            <h3>Add QR code to your authenticator app</h3>
          </div>
          <p class="subtitle">
            Enter the 6-digit code from your authenticator app to enable 2FA for your account.
          </p>
          <div class="otp-container">
            @for (ctrl of otpForm.controls | keyvalue; track ctrl; let i = $index) {
              <input #F type="text" placeholder="0"
                inputmode="numeric" autocomplete="one-time-code" [formControlName]="'d' + i"
                (keydown)="onKeyDown($event, i)" (input)="onInput($event, i)" />
            }
          </div>
        </div>
      }

      @if (isError) {
        <mat-error class="error-message"> {{ErrorMessage}} </mat-error>
      }
    </div>

  </div>

</div>
</div>
